const BASE = process.env.REACT_APP_API_URL || '';

async function request(method, path, body, pin) {
  const headers = { 'Content-Type': 'application/json' };
  if (pin) headers['x-trainer-pin'] = pin;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status}: ${text}`);
  }
  return res.json();
}

export const api = {
  getWeeks: () => request('GET', '/api/weeks'),
  saveWeek: (week, data, pin) => request('PUT', `/api/weeks/${week}`, data, pin),
  verifyPin: (pin) => request('POST', '/api/pin/verify', { pin }),
};
